module.exports = __webpack_public_path__ + "img/检验检测.8963a025.png";